<form (ngSubmit)="save()" #f="ngForm">

  <div class="edit-panel__close" (click)="cancel()">
    <i class="material-icons">highlight_off</i>
  </div>

  <h2 class="edit-panel__heading">{{title}}</h2>
  <!--<ul class="edit-panel__list edit-panel__main-edit">
    <li class="edit-panel__item edit--group-panel row">
      <mat-form-field fxFlex="100" class="edit-panel__material-holder">
        <input matInput type="text" placeholder="Name" [(ngModel)]="questionGroup.name" name="name" required />
      </mat-form-field>
      <div class="edit-panel__help" matTooltip="This name will only be used in the admin area" matTooltipPosition='right'>
        <mat-icon>help</mat-icon>
      </div>
    </li>
    <li class="edit-panel__item edit--group-panel row">
      <mat-form-field fxFlex="100" class="edit-panel__material-holder">
        <input matInput type="text" placeholder="Description" [(ngModel)]="questionGroup.description" name="description"
               required />
      </mat-form-field>
      <div class="edit-panel__help" matTooltip="This is how the question group will be displayed in the forms" matTooltipPosition='right'>
        <mat-icon>help</mat-icon>
      </div>
    </li>
  </ul>-->
  <ul class="grid grid--row-1">
    <li class="edit-panel__row">
      <mat-form-field>
        <div class="validation__holder">
          <input matInput type="text" placeholder="Name" [(ngModel)]="questionGroup.name" name="name" required />
          <div class="validation"></div>
        </div>
      </mat-form-field>
      <div class="edit-panel__help" matTooltip="This name will only be used in the admin area" matTooltipPosition='right'>
        <mat-icon>help</mat-icon>
      </div>
    </li>
    <li class="edit-panel__row">
      <mat-form-field>
        <div class="validation__holder">
          <input matInput type="text" placeholder="Description" [(ngModel)]="questionGroup.description" name="description" required />
          <div class="validation"></div>
        </div>
      </mat-form-field>
      <div class="edit-panel__help" matTooltip="This is how the question group will be displayed in the forms" matTooltipPosition='right'>
        <mat-icon>help</mat-icon>
      </div>
    </li>
  </ul>
  <br /><br />
  <div class="button__row">
    <a class="button--box red delete" title="Delete" (click)="delete()" *ngIf="isEditMode">Delete</a>
    <div *ngIf="!isEditMode"></div>
    <!--<input type="submit" class="button--box blue save" title="Save" value="Save" [disabled]="isSubmitDisabled()" />-->
    <button class="button--box blue save" (click)="save()" [disabled]="isSubmitDisabled()">Save</button>
  </div>
</form>
